import { LoadCssResolver } from '@b2c/common/resolvers';
import { ComboServiceModule } from '@b2c/common/services/combo/combo.service';
import { EventsServiceModule } from '@b2c/common/services/events/events.service';
import { MembershipServiceModule } from '@b2c/common/services/membership/membership.service';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { EventsDetailControllerModule } from './controllers/EventsDetailController';

export const EventsDetailView = angular
  .module('acme.view.events.detail', [
    uiRouter,
    'ui.bootstrap',
    EventsServiceModule,
    MembershipServiceModule,
    ComboServiceModule,
    EventsDetailControllerModule,
  ])
  .config(function config($stateProvider) {
    const eventsDetail = {
      name: 'events.detail',
      url: '/detail/:eventId?comboId&membershipIds&date&rev',
      views: {
        'subview-main': {
          controller: 'EventsDetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: '',
      },
      resolve: {
        EventTemplateData: [
          '$stateParams',
          'EventsService',
          'MembershipService',
          function ($stateParams, EventsService, MembershipService) {
            let membershipIds;

            if (!MembershipService.checkExpiredVerifiedMembership($stateParams.tenantId)) {
              membershipIds = MembershipService.getMembershipIds(true).join();
            }

            if ($stateParams.eventId && !$stateParams.comboId) {
              return EventsService.api.detail({
                tenantId: $stateParams.tenantId,
                eventTemplateId: $stateParams.eventId,
                membershipId: membershipIds || null,
              });
            } else {
              return {
                data: {
                  success: false,
                },
              };
            }
          },
        ],
        ComboTemplateData: [
          '$stateParams',
          'ComboService',
          function ($stateParams, ComboService) {
            if ($stateParams.comboId) {
              return ComboService.api.detail({
                tenantId: $stateParams.tenantId,
                comboTemplateId: $stateParams.comboId,
                summary: true,
              });
            } else {
              return {
                data: {
                  success: false,
                },
              };
            }
          },
        ],
        lightboxCss: LoadCssResolver({ id: 'lightbox-css', url: '/assets/assets/lightbox.css' }),
      },
    };

    $stateProvider.state(eventsDetail);
  }).name;
